import { Link } from 'react-router-dom';
import { buildDeviceHistoryPath } from '../pages/deviceHistoryPath';

function DeviceIcon({ className }) {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3.2" y="1.8" width="9.6" height="12.4" rx="1.4" />
      <path d="M6.2 12.2h3.6" />
    </svg>
  );
}

/** Icon that opens device history. With `onOpen`, stays on the page in a modal. */
export default function DeviceHistoryLinkButton({ deviceId, serialNumber, size = 'sm', onOpen = null }) {
  const path = buildDeviceHistoryPath(deviceId, { serialNumber });
  if (!path) {
    return null;
  }

  const box = size === 'lg' ? 'h-8 w-8' : 'h-6 w-6';
  const icon = size === 'lg' ? 'h-4 w-4' : 'h-3.5 w-3.5';
  const label = serialNumber
    ? `История устройства ${serialNumber}`
    : 'История устройства';
  const className = `peer inline-flex ${box} items-center justify-center rounded-full border border-slate-300 text-slate-500 transition hover:border-violet-400 hover:text-violet-700 dark:border-slate-700 dark:text-slate-400 dark:hover:text-violet-200`;

  return (
    <div className="relative inline-flex">
      {onOpen ? (
        <button
          type="button"
          aria-label={label}
          title="История устройства"
          className={className}
          onClick={() => onOpen({ deviceId, serialNumber })}
        >
          <DeviceIcon className={icon} />
        </button>
      ) : (
        <Link
          to={path}
          aria-label={label}
          title="История устройства"
          className={className}
        >
          <DeviceIcon className={icon} />
        </Link>
      )}
      <span className="pointer-events-none absolute left-1/2 top-full z-[60] mt-1 -translate-x-1/2 whitespace-nowrap rounded-md border border-slate-300 bg-white px-2 py-1 text-[11px] text-slate-800 opacity-0 shadow-lg peer-hover:opacity-100 peer-focus:opacity-100 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200">
        История устройства
      </span>
    </div>
  );
}
